import { setIsConformationModalOpen } from "../EstablishmentsSlice";
import { setActiveEstablishmentId } from "../../../app/rootReducer";
import { RouteEnum } from "../../../common/enums/RouteEnum";
import { Popup, Button } from "@hatch-digital-nl/abs-storybook/legacy";
import { useNavigate } from "react-router";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { JSX } from "react";

export const EstablishmentsPopup = (): JSX.Element | null => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { establishment, isConformationModalOpen } = useAppSelector(
        (state) => state.establishments,
    );

    if (!isConformationModalOpen) {
        return null;
    }

    return (
        <Popup
            className={"p-establishments__content__popup"}
            title={"Vestiging wisselen"}
            onCloseClick={() => dispatch(setIsConformationModalOpen(false))}
        >
            <p className={"p-establishments__content__popup__text"}>
                Weet je zeker dat je wilt wisselen naar vestiging{" "}
                <span>{establishment.name}?</span> Je wordt dan uitgelogd bij de
                huidige vestiging.
            </p>
            <div className={"p-establishments__content__popup__buttons"}>
                <Button
                    variant={"primary"}
                    onClick={() => {
                        dispatch(setActiveEstablishmentId(establishment.id));
                        dispatch(setIsConformationModalOpen(false));
                        navigate(RouteEnum.DASHBOARD);
                    }}
                >
                    Ik wil wisselen
                </Button>
                <Button
                    variant={"tertiary"}
                    onClick={() => dispatch(setIsConformationModalOpen(false))}
                >
                    Terug naar overzicht
                </Button>
            </div>
        </Popup>
    );
};
